module.exports = VueDraggablePlus;